/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BillingControllerInvoicesV1200,
  BillingControllerInvoicesV1Params,
  BillingOverviewDto,
  CreateSalesRequestDto,
  PaymentMethodDto,
  PlanSwitchRefusedDto,
  SalesRequestCreatedDto,
  SubscribeDto,
  SubscriptionDto,
  UpdatePaymentMethodDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getBillingControllerOverviewV1Url = () => {




  return `/v1/billing`
}

/**
 * @summary The billing screen: plan, limits, usage, card, tiers
 */
export const billingControllerOverviewV1 = async ( options?: RequestInit): Promise<BillingOverviewDto> => {

  return apiRequest<BillingOverviewDto>(getBillingControllerOverviewV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBillingControllerOverviewV1QueryKey = () => {
    return [
    `/v1/billing`
    ] as const;
    }


export const getBillingControllerOverviewV1QueryOptions = <TData = Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingControllerOverviewV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerOverviewV1>>> = ({ signal }) => billingControllerOverviewV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingControllerOverviewV1QueryResult = NonNullable<Awaited<ReturnType<typeof billingControllerOverviewV1>>>
export type BillingControllerOverviewV1QueryError = unknown


export function useBillingControllerOverviewV1<TData = Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerOverviewV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerOverviewV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerOverviewV1<TData = Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerOverviewV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerOverviewV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerOverviewV1<TData = Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The billing screen: plan, limits, usage, card, tiers
 */

export function useBillingControllerOverviewV1<TData = Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerOverviewV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingControllerOverviewV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getBillingControllerInvoicesV1Url = (params?: BillingControllerInvoicesV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/billing/invoices?${stringifiedParams}` : `/v1/billing/invoices`
}

/**
 * @summary Invoices (paginated, searchable, orderable)
 */
export const billingControllerInvoicesV1 = async (params?: BillingControllerInvoicesV1Params, options?: RequestInit): Promise<BillingControllerInvoicesV1200> => {

  return apiRequest<BillingControllerInvoicesV1200>(getBillingControllerInvoicesV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getBillingControllerInvoicesV1QueryKey = (params?: BillingControllerInvoicesV1Params,) => {
    return [
    `/v1/billing/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getBillingControllerInvoicesV1QueryOptions = <TData = Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError = unknown>(params?: BillingControllerInvoicesV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingControllerInvoicesV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerInvoicesV1>>> = ({ signal }) => billingControllerInvoicesV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingControllerInvoicesV1QueryResult = NonNullable<Awaited<ReturnType<typeof billingControllerInvoicesV1>>>
export type BillingControllerInvoicesV1QueryError = unknown


export function useBillingControllerInvoicesV1<TData = Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError = unknown>(
 params: undefined |  BillingControllerInvoicesV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerInvoicesV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerInvoicesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerInvoicesV1<TData = Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError = unknown>(
 params?: BillingControllerInvoicesV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerInvoicesV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerInvoicesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerInvoicesV1<TData = Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError = unknown>(
 params?: BillingControllerInvoicesV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Invoices (paginated, searchable, orderable)
 */

export function useBillingControllerInvoicesV1<TData = Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError = unknown>(
 params?: BillingControllerInvoicesV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerInvoicesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingControllerInvoicesV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getBillingControllerSubscribeV1Url = () => {




  return `/v1/billing/subscribe`
}

/**
 * @summary Start or switch the plan (simulated charge). 409 with `overages` when usage exceeds the new limits.
 */
export const billingControllerSubscribeV1 = async (subscribeDto: SubscribeDto, options?: RequestInit): Promise<SubscriptionDto> => {

  return apiRequest<SubscriptionDto>(getBillingControllerSubscribeV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(subscribeDto)
  }
);}





export const getBillingControllerSubscribeV1QueryKey = (subscribeDto?: SubscribeDto,) => {
    return [
    'POST', `/v1/billing/subscribe`, subscribeDto
    ] as const;
    }


export const getBillingControllerSubscribeV1QueryOptions = <TData = Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError = PlanSwitchRefusedDto>(subscribeDto: SubscribeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingControllerSubscribeV1QueryKey(subscribeDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerSubscribeV1>>> = ({ signal }) => billingControllerSubscribeV1(subscribeDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingControllerSubscribeV1QueryResult = NonNullable<Awaited<ReturnType<typeof billingControllerSubscribeV1>>>
export type BillingControllerSubscribeV1QueryError = PlanSwitchRefusedDto


export function useBillingControllerSubscribeV1<TData = Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError = PlanSwitchRefusedDto>(
 subscribeDto: SubscribeDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerSubscribeV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerSubscribeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerSubscribeV1<TData = Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError = PlanSwitchRefusedDto>(
 subscribeDto: SubscribeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerSubscribeV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerSubscribeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerSubscribeV1<TData = Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError = PlanSwitchRefusedDto>(
 subscribeDto: SubscribeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Start or switch the plan (simulated charge). 409 with `overages` when usage exceeds the new limits.
 */

export function useBillingControllerSubscribeV1<TData = Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError = PlanSwitchRefusedDto>(
 subscribeDto: SubscribeDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerSubscribeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingControllerSubscribeV1QueryOptions(subscribeDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getBillingControllerCancelV1Url = () => {




  return `/v1/billing/cancel`
}

/**
 * @summary Cancel at the end of the current period
 */
export const billingControllerCancelV1 = async ( options?: RequestInit): Promise<SubscriptionDto> => {

  return apiRequest<SubscriptionDto>(getBillingControllerCancelV1Url(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBillingControllerCancelV1QueryKey = () => {
    return [
    'POST', `/v1/billing/cancel`
    ] as const;
    }


export const getBillingControllerCancelV1QueryOptions = <TData = Awaited<ReturnType<typeof billingControllerCancelV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerCancelV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingControllerCancelV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerCancelV1>>> = ({ signal }) => billingControllerCancelV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingControllerCancelV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingControllerCancelV1QueryResult = NonNullable<Awaited<ReturnType<typeof billingControllerCancelV1>>>
export type BillingControllerCancelV1QueryError = unknown


export function useBillingControllerCancelV1<TData = Awaited<ReturnType<typeof billingControllerCancelV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerCancelV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerCancelV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerCancelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerCancelV1<TData = Awaited<ReturnType<typeof billingControllerCancelV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerCancelV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerCancelV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerCancelV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerCancelV1<TData = Awaited<ReturnType<typeof billingControllerCancelV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerCancelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Cancel at the end of the current period
 */

export function useBillingControllerCancelV1<TData = Awaited<ReturnType<typeof billingControllerCancelV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerCancelV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingControllerCancelV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getBillingControllerResumeV1Url = () => {




  return `/v1/billing/resume`
}

/**
 * @summary Undo a cancellation before the period ends
 */
export const billingControllerResumeV1 = async ( options?: RequestInit): Promise<SubscriptionDto> => {

  return apiRequest<SubscriptionDto>(getBillingControllerResumeV1Url(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBillingControllerResumeV1QueryKey = () => {
    return [
    'POST', `/v1/billing/resume`
    ] as const;
    }


export const getBillingControllerResumeV1QueryOptions = <TData = Awaited<ReturnType<typeof billingControllerResumeV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerResumeV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingControllerResumeV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerResumeV1>>> = ({ signal }) => billingControllerResumeV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingControllerResumeV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingControllerResumeV1QueryResult = NonNullable<Awaited<ReturnType<typeof billingControllerResumeV1>>>
export type BillingControllerResumeV1QueryError = unknown


export function useBillingControllerResumeV1<TData = Awaited<ReturnType<typeof billingControllerResumeV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerResumeV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerResumeV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerResumeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerResumeV1<TData = Awaited<ReturnType<typeof billingControllerResumeV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerResumeV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerResumeV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerResumeV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerResumeV1<TData = Awaited<ReturnType<typeof billingControllerResumeV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerResumeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Undo a cancellation before the period ends
 */

export function useBillingControllerResumeV1<TData = Awaited<ReturnType<typeof billingControllerResumeV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerResumeV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingControllerResumeV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getBillingControllerRetryPaymentV1Url = () => {




  return `/v1/billing/retry-payment`
}

/**
 * @summary Past due only: charge the card on file again
 */
export const billingControllerRetryPaymentV1 = async ( options?: RequestInit): Promise<SubscriptionDto> => {

  return apiRequest<SubscriptionDto>(getBillingControllerRetryPaymentV1Url(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBillingControllerRetryPaymentV1QueryKey = () => {
    return [
    'POST', `/v1/billing/retry-payment`
    ] as const;
    }


export const getBillingControllerRetryPaymentV1QueryOptions = <TData = Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingControllerRetryPaymentV1QueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>> = ({ signal }) => billingControllerRetryPaymentV1({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingControllerRetryPaymentV1QueryResult = NonNullable<Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>>
export type BillingControllerRetryPaymentV1QueryError = unknown


export function useBillingControllerRetryPaymentV1<TData = Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerRetryPaymentV1<TData = Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerRetryPaymentV1<TData = Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Past due only: charge the card on file again
 */

export function useBillingControllerRetryPaymentV1<TData = Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerRetryPaymentV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingControllerRetryPaymentV1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getBillingControllerUpdatePaymentMethodV1Url = () => {




  return `/v1/billing/payment-method`
}

/**
 * @summary Replace the card on file (simulated)
 */
export const billingControllerUpdatePaymentMethodV1 = async (updatePaymentMethodDto: UpdatePaymentMethodDto, options?: RequestInit): Promise<PaymentMethodDto> => {

  return apiRequest<PaymentMethodDto>(getBillingControllerUpdatePaymentMethodV1Url(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePaymentMethodDto)
  }
);}





export const getBillingControllerUpdatePaymentMethodV1QueryKey = (updatePaymentMethodDto?: UpdatePaymentMethodDto,) => {
    return [
    'PUT', `/v1/billing/payment-method`, updatePaymentMethodDto
    ] as const;
    }


export const getBillingControllerUpdatePaymentMethodV1QueryOptions = <TData = Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError = unknown>(updatePaymentMethodDto: UpdatePaymentMethodDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingControllerUpdatePaymentMethodV1QueryKey(updatePaymentMethodDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>> = ({ signal }) => billingControllerUpdatePaymentMethodV1(updatePaymentMethodDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingControllerUpdatePaymentMethodV1QueryResult = NonNullable<Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>>
export type BillingControllerUpdatePaymentMethodV1QueryError = unknown


export function useBillingControllerUpdatePaymentMethodV1<TData = Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError = unknown>(
 updatePaymentMethodDto: UpdatePaymentMethodDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerUpdatePaymentMethodV1<TData = Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError = unknown>(
 updatePaymentMethodDto: UpdatePaymentMethodDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerUpdatePaymentMethodV1<TData = Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError = unknown>(
 updatePaymentMethodDto: UpdatePaymentMethodDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Replace the card on file (simulated)
 */

export function useBillingControllerUpdatePaymentMethodV1<TData = Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError = unknown>(
 updatePaymentMethodDto: UpdatePaymentMethodDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerUpdatePaymentMethodV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingControllerUpdatePaymentMethodV1QueryOptions(updatePaymentMethodDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getBillingControllerContactSalesV1Url = () => {




  return `/v1/billing/sales-requests`
}

/**
 * @summary "Contact sales" from the Enterprise card
 */
export const billingControllerContactSalesV1 = async (createSalesRequestDto: CreateSalesRequestDto, options?: RequestInit): Promise<SalesRequestCreatedDto> => {

  return apiRequest<SalesRequestCreatedDto>(getBillingControllerContactSalesV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createSalesRequestDto)
  }
);}





export const getBillingControllerContactSalesV1QueryKey = (createSalesRequestDto?: CreateSalesRequestDto,) => {
    return [
    'POST', `/v1/billing/sales-requests`, createSalesRequestDto
    ] as const;
    }


export const getBillingControllerContactSalesV1QueryOptions = <TData = Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError = unknown>(createSalesRequestDto: CreateSalesRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getBillingControllerContactSalesV1QueryKey(createSalesRequestDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerContactSalesV1>>> = ({ signal }) => billingControllerContactSalesV1(createSalesRequestDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type BillingControllerContactSalesV1QueryResult = NonNullable<Awaited<ReturnType<typeof billingControllerContactSalesV1>>>
export type BillingControllerContactSalesV1QueryError = unknown


export function useBillingControllerContactSalesV1<TData = Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError = unknown>(
 createSalesRequestDto: CreateSalesRequestDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerContactSalesV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerContactSalesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerContactSalesV1<TData = Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError = unknown>(
 createSalesRequestDto: CreateSalesRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerContactSalesV1>>,
          TError,
          Awaited<ReturnType<typeof billingControllerContactSalesV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useBillingControllerContactSalesV1<TData = Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError = unknown>(
 createSalesRequestDto: CreateSalesRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary "Contact sales" from the Enterprise card
 */

export function useBillingControllerContactSalesV1<TData = Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError = unknown>(
 createSalesRequestDto: CreateSalesRequestDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof billingControllerContactSalesV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getBillingControllerContactSalesV1QueryOptions(createSalesRequestDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






